import { getPreloadedState } from './get-preloaded-state';

export default () => {
    const preloadedState = getPreloadedState();
    const cloudAPIHost = preloadedState?.config?.yaServices.cloudAPIHost;
    if (cloudAPIHost) {
        return `https://${cloudAPIHost}`;
    } else {
        return 'https://cloud-api.yandex.ru';
    }
};
